new WOW().init();
var wows = document.getElementsByClassName('wow')
for (i = 0; i < wows.length; i++){
  wows[i].style.visibility ='hidden';
}

(function($) {


  $(document).ready(function() {
		
        $('img.svg').each(function(){
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                
                               
                var $svg = jQuery(data).find('svg');
				$svg = $svg.remove('style');
                
//                 console.log( $svg );
                

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');
               

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        }); // img.svg
        
        
        $('.single-job #career-subject').val( 'Ogłoszenie: ' + $('.type-job h1').text() );


		// if( $( window ).width() < 767 ) {

	        // $('.dropdown > a').attr({
		        // 'href': '#',
		        // 'data-toggle': 'dropdown'
	        // });
        
        // }
        
        
		 

		$('.go-to-up').click(function(event) {
			event.preventDefault();
			
			
			var body = $("html, body");
			body.stop().animate({
				scrollTop: 0
			}, 500, 'swing');
			
			
			return false;
		});
		
		
		lightbox.option({
		  'albumLabel':  "%1/%2"
		});
		
		
		
		
		 
		
		var bodyWidth = $( window ).width();
		if( bodyWidth > 1200) {
			var $halfslider_animation = "slide";
		} else {
			var $halfslider_animation = "fade";
		}   
		
		if($halfSliders.length > 0)
		{
			for(var i = 0; i < $halfSliders.length; i++)
			{
				var thisSlider = $halfSliders[i];
				$('.halfslider' + thisSlider).flexslider({
					animation: $halfslider_animation,
					slideshowSpeed: 4000, 
					animationSpeed: 700, 
					pauseOnHover: false,
					touch: true,
					smoothHeight: true,
					controlsContainer: $(".nav-container-halfslider"),
					after:  function(slider){
						 
						var current = slider.find(".flex-active-slide");
						
						var currentContent = current.data("from_slide");
						
						$(currentContent).css("opacity", "1");
						$(currentContent).html(current.data("slide_text"));  
						slider.flexslider('pause');
						slider.flexslider('play');
					},
					before:  function(slider){
						var current = slider.find(".flex-active-slide");
						var currentContent = current.data("from_slide");
						 
						
						if(!slider.hasClass("no-animation"))
							$(currentContent).css("opacity", "0");
						
					}, 
					start: function(slider){
						var current = slider.find(".flex-active-slide");
						var currentContent = current.data("from_slide"); 
						$(currentContent).html(current.data("slide_text"));  
					}
				  });
 
			} 
			$(".half-prev").click(function(e) {
				e.preventDefault(); 
				var currentContent = $(this).data("from_slide");
			 
				$('.halfslider'+ currentContent).flexslider('prev');
				
			});
			$(".half-next").click(function(e) { 
				e.preventDefault(); 
				var currentContent = $(this).data("from_slide");
				 
				$('.halfslider'+ currentContent).flexslider('next');
				
			});
		}
		
		$("#bgimage").stop().animate({opacity: 0},1000,function(){
			$(this).css({'background-image': "url('/images/alt_image.png')"})
				.animate({opacity: 1},{duration:1000});
		});  
		 
		if(typeof backStretchImages != "undefined") {  
			 $.backstretch(backStretchImages, {duration: 5000, fade: 1000});
		}
		 
		// $(".modal-wide").on("show.bs.modal", function() {
			// var height = $(window).height() - 200;
			// $(this).find(".modal-body").css("max-height", height);
		// });
		
		
		
		$(".proj-container").click(function(e) {
			 
			e.preventDefault();
			var $projId = $(this).data("project-id");
			var data = {
				'project_id': $projId, 
				'action': 'get_project_info'
			};
			
			$.post(v.ajaxurl, data, function(response) { 
				 
				$('#projectModal').modal("show");
				
				$('.project-slider').html("");
				
				var $html = "<ul class='slides'>";
				for(var i = 0; i < response.images.length; i++) 
				{
					 
					$html += "<li class='slide'><div class='img-slider' style='background-image: url("+ response.images[i] +"); '></li>"; 
					
				}
				$html += "</ul>"; 
				$(".slide-number").html("1 / "+ response.images.length);
				$('.project-slider').html($html);
				$(".info-scroll").html(response.project_desc);
				
				 
			});
			
			
			
		});  
		$('#projectModal').on('shown.bs.modal', function (e) {
		 
			setEqualHeight('.slides .img-slider');
			$('.project-slider').flexslider({
				animation: "fade",
				touch: true,
				after: function(slide) {
					 
					var $cslide = slide.currentSlide + 1;
					$(".slide-number").html($cslide + " / "+ slide.count);
				}
			})
		});
		
		$('#projectModal').on('hidden.bs.modal', function (e) {
			$(".project-info-text").css("height", "0px");
		});
		
		$(".cursor-left").click(function(e) {
			$('.project-slider').flexslider("prev");
		});
		
		$(".cursor-right").click(function(e) {
			$('.project-slider').flexslider("next");
		});
		
		$(".project-info-button").click(function(e) {
			 $(".project-info-text").css("height", "66%");
		});
		$(".project-info-button-close").click(function(e) {
			 $(".project-info-text").css("height", "0px");
		});
		
		
		
		
		$('#projectModal').on('hidden.bs.modal', function (e) {
			 
			setTimeout(function() {
				flexdestroy('.project-slider');
			}, 500);
		});
		
		$(window).resize(function() {

			setTimeout(function() {
				setEqualHeight('.slides .img-slider');
			}, 120);
		});
		function setEqualHeight(selector) {
			var heights = new Array();

			$(selector).each(function() {

				$(this).css('min-height', '0');
				$(this).css('max-height', 'none');
				$(this).css('height', 'auto');

				heights.push($(this).height());
			});

			var max = $(window).height();
			$(selector).each(function() {
				$(this).css('height', max + 'px');
			}); 
		}
		
		function flexdestroy(selector) {

		  var $els = $(selector);

		  $els.each(function() {
			var $el = $(this);
			var $elClean = $el.clone();

			$elClean.find('.flex-viewport').children().unwrap();
			$elClean
			  .removeClass('flexslider')
			  .find('.clone, .flex-direction-nav, .flex-control-nav')
				.remove()
				.end()
			  .find('*').removeAttr('style').removeClass(function (index, css) {
				// If element is SVG css has an Object inside (?)
				if (typeof css === 'string') {
				  return (css.match(/\bflex\S+/g) || []).join(' ');
				}
			  });

			$elClean.insertBefore($el);
			$el.remove();
		  });

		}
		if(project_slug != "")
		{
			$("."+project_slug).trigger("click");  
		}
		
  });
  
	 

})(jQuery);





var Slider = (function($)
{
	var _public = {
		
		slider: function()
		{
			$('.slider-section').flexslider({
				controlNav: true,
				directionNav: false,  
				slideshowSpeed: 4000, 
				after:  function(slider){
 
						slider.flexslider('pause');
						slider.flexslider('play');
					},
			});
			
			 
		},
		
		init: function()
		{
			$( document ).ready( _public.slider );
		}
	}
	
	
	return _public;
}(jQuery)).init();


